<template>
  <div class="admin-page">
    <AdminSidebar />
    <!-- header -->
    <header class="header">
      <!-- main-navbar -->
      <b-navbar toggleable="lg" class="navbar navbar-expand-lg navbar-dark main-navbar">
        <div class="container">
          <b-navbar-brand href="#">
            <router-link to="/" tag="span">Brand</router-link>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <router-link class="nav-item" tag="li" active-class="active" to="/admin/products">
                <a class="nav-link" href="#">Products</a>
              </router-link>
              <router-link class="nav-item" tag="li" active-class="active" to="/admin/profile">
                <a class="nav-link" href="#">Profile</a>
              </router-link>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <form class="d-flex search-box m-auto">
                <input
                  class="form-control input"
                  type="search"
                  placeholder="Search"
                  name="serach-value"
                />
                <button class="btn main-btn" type="submit">
                  <i class="fa fa-search"></i>
                </button>
              </form>
              <template v-if="auth">
                <li class="nav-item">
                  <a class="nav-link" href="#" @click.prevent="signOut">log out</a>
                </li>
              </template>
            </b-navbar-nav>
          </b-collapse>
        </div>
      </b-navbar>
      <!-- end main-navbar -->
    </header>
    <!-- end header -->
    <router-view></router-view>
  </div>
</template>

<script>
import AdminSidebar from "../../components/admin/AdminSidebar";
export default {
    computed: {
    auth() {
      return this.$store.getters["authModule/getUser"];
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch("authModule/signOut");
      this.$router.push("/");
    }
  },
  data() {
    return {
      openSideBar: false
    };
  },
  components: {
    AdminSidebar
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/_variables.scss";
.admin-page {
  position: relative;
}
</style>

